import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import NaturalColorsExplosion from "./sections/NaturalColorsExplosion";
import AboutOurCompany from "./sections/AboutOurCompany";
import OurEngineeringValues from "./sections/OurEngineeringValues";
import WhyWartmannUmzuege from "./sections/WhyWartmannUmzuege";
import Testimonials from "./sections/Testimonials";
import ScaleYourContent from "./sections/ScaleYourContent";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <NaturalColorsExplosion />
      <AboutOurCompany />
      <OurEngineeringValues />
      <WhyWartmannUmzuege />
      <Testimonials />
      <ScaleYourContent />
      <Footer />
    </div>;
}